/* eslint-disable no-param-reassign */
import { trpc } from '@tencent/tpro_rmonitor_login_server_login_auth';
import constate from 'constate';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { userImplement } from '@/config/hooks/user';
import { AuthUser } from '@/config/hooks/user/types';
import { storageSet } from '@/infrastructure/storage-utils';
import { useStores } from '@/presentation/store';
import { WithTypeCast } from '@raft/utils';
import { BUGLY_LOGIN_STORAGE_KEY, Token, BUGLY_LAST_LOGIN, LoginType } from './types';
import { redirectToPrevPage } from './utils';
type IUserInfo = WithTypeCast<trpc.rmonitor.login_server.IUserInfo>;

// const defaultAuthInfo: AuthInfo = {
//   isLoggedIn: false,
//   lastLoginUin: storageGet(BUGLY_LAST_LOGIN) || '',
// };


// if (!isInternal()) {
//   const oaName = getUserId();
//   return {
//     // 过了智能网关，所以肯定登录了
//     isLoggedIn: true,
//     userInfo: {
//       buglyUserId: oaName,
//       buglyUserName: oaName,
//     },
//   };
// }

// try {
//   const storageAuthInfo = JSON.parse(localStorage.getItem(BUGLY_LOGIN_STORAGE_KEY) as string) as AuthInfo;
//   return storageAuthInfo || defaultAuthInfo;
// } catch (e) {
//   return defaultAuthInfo;
// }

const initAuthInfo = (): AuthUser => userImplement.initUserInfo();

interface AuthProps {
  location: Location;
}

/**
 * 处理登录态校验、权限校验等全局逻辑，并提供相应数据给子组件
 */
const useAuth = (props: AuthProps) => {
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setHasProduct } = useStores().ProductStore;
  const [authInfo, setAuthInfo] = useImmer<AuthUser>(initAuthInfo());
  const history = useHistory();

  const loginSuccessHandler = (
    loginType: LoginType,
    userInfo: IUserInfo,
    token?: Token,
  ) => {
    userImplement.onLogin(loginType, userInfo, token);
    saveUserInfo(loginType, userInfo, token);
  };

  const saveUserInfo = (
    _loginType: LoginType,
    userInfo: IUserInfo,
    token?: Token,
  ) => {
    setAuthInfo((draft) => {
      draft.isLoggedIn = true;
      // draft.loginType = loginType;
      draft.userInfo = userInfo;
      // draft.token = token;
      storageSet(BUGLY_LOGIN_STORAGE_KEY, JSON.stringify(draft));
    });

    // 记住上次登录的账号
    storageSet(BUGLY_LAST_LOGIN, token?.uin);
    redirectToPrevPage();
  };

  useEffect(() => {
    userImplement.checkLogin(props.location.pathname, history);
  }, [props.location.pathname]);

  return {
    authInfo,
    onLoginSuccess: loginSuccessHandler,
  };
};


const [AuthProvider, useAuthContext] = constate<any, any, any>(useAuth);

export {
  AuthProvider,
  useAuthContext,
};
